import { render, staticRenderFns } from "./Nutrition.vue?vue&type=template&id=32361b38&scoped=true"
import script from "./Nutrition.vue?vue&type=script&lang=js"
export * from "./Nutrition.vue?vue&type=script&lang=js"
import style0 from "./Nutrition.vue?vue&type=style&index=0&id=32361b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32361b38",
  null
  
)

export default component.exports